import { DeleteProjectModalProps } from 'Features/Project/DeleteProjectModal/DeleteProjectModal.types'
import { ContentWrapper, ButtonGroup } from './DeleteProjectModal.styles'
import { Typography } from '@mui/material'
import { Button, Modal } from 'Common/Supplyvue-ui'

export const DeleteProjectModal = ({
  isModalOpen,
  handleModalClose,
  projectName,
  handleConfirmClick,
}: DeleteProjectModalProps) => {
  const body = (
    <ContentWrapper>
      <Typography>
        Are you sure you want to delete project
        <Typography variant="h4">{projectName}</Typography>
      </Typography>

      <ButtonGroup>
        <Button variant="outlined" onClick={handleModalClose}>
          No
        </Button>
        <Button variant="contained" onClick={handleConfirmClick}>
          Yes
        </Button>
      </ButtonGroup>
    </ContentWrapper>
  )

  return (
    <Modal
      open={isModalOpen}
      handleClose={handleModalClose}
      body={body}
      aria-labelledby={'Delete project'}
      header={'Delete project'}
    />
  )
}
